import React, { useState, useEffect } from "react";

// Components
import DashboardHeader from './merchant/dashboard/components/DashboardHeader';
import KPISection from './merchant/dashboard/components/KPISection';
import SegmentSection from './merchant/dashboard/components/SegmentSection';
import { dashboardService } from '../services/apiService';
import { customerService } from '../services/apiService';
import { StatsSkeleton } from '../services/service';
import SummaryStats from './merchant/customer/components/SummaryStats';
import { User2Icon } from "lucide-react";
const Dashboard = () => {
  const [selectedSegmentId, setSelectedSegmentId] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingStats, setLoadingStats] = useState(true); // State loading riêng cho stats
  const [statsData, setStatsData] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await dashboardService.getOverview();
      setDashboardData(response?.data || { kpi: {}, segment: {} });
    } catch (error) {
      console.error("Error fetching revenue data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoadingStats(true);
        const response = await customerService.getGlobalCustomerStats();
        setStatsData(response.data);
      } catch (error) {
        console.error("Lỗi lấy thống kê khách hàng:", error);
      } finally {
        setLoadingStats(false);
      }
    };

    // Tạo một hàm async cục bộ để điều phối chạy tuần tự
    const loadDataSequentially = async () => {
      await fetchData(); // Dừng ở đây chờ fetchData xong hoàn toàn
      await fetchStats(); // Xong fetchData mới bắt đầu chạy dòng này
    };

    loadDataSequentially();
  }, []); // Nếu ESLint báo vàng ở đây, bạn có thể bọc fetchData bằng useCallback nhé

  // Data Processing
  const mappedSummary = {
    totalCustomers: statsData?.total_customers || 0,
    totalWithPhone: statsData?.total_phones || 0,
    totalWithMBPhone: statsData?.total_mb_bank_phones || 0,
    totalWithOtherPhone: statsData?.total_non_mb_phones || 0,
    totalMB: statsData?.total_mb_bank || 0,
    totalOther: statsData?.total_non_mb || 0,
  };

  const kpi = dashboardData?.kpi || {};
  const segmentStats = dashboardData?.segment || {};
  const totalMerchants = Object.values(segmentStats).reduce(
    (a, b) => a + (Number(b) || 0),
    0,
  );

  if (loading && !dashboardData) {
    // Loading state ban đầu (nếu muốn)
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800 pb-10">
      <DashboardHeader onRefresh={fetchData} loading={loading} />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-8">
        <KPISection kpi={kpi} />
        <div className="flex items-center justify-between">
          <h2 className="text-sm font-bold text-slate-500 uppercase tracking-wider flex items-center gap-2">
            <User2Icon size={16} /> Tổng quan khách hàng
          </h2>
        </div>
        {loadingStats ? (
          <StatsSkeleton />
        ) : (
          <SummaryStats summary={mappedSummary} />
        )}
        <SegmentSection
          segmentStats={segmentStats}
          totalMerchants={totalMerchants}
          selectedSegmentId={selectedSegmentId}
          onSelectSegment={setSelectedSegmentId}
        />
      </main>
    </div>
  );
};

export default Dashboard;
